<template>
  <button
    @click.stop="handleRoundBtnClick"
    :style="{backgroundColor: backgroundColor, backgroundImage: `url(${backgroundImg})`}"
    :class="{all: isAll, top: isTop}"
  >
    <slot></slot>
  </button>
</template>

<script>

export default {
  name: 'RoundButton',

  props: {
    backgroundColor: {
      type: String,
      default: '#000',
    },
    backgroundImg: {
      type: String,
      default: '',
    },
    isAll: {
      type: Boolean,
      default: false,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleRoundBtnClick() {
      this.$emit('handleRoundBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  color: $white;
  font-size: 16px;
  font-weight: 700;
  border-radius: 25px;
  padding: 18px 12px;
  transition: .4s;
  // background-size: 100% 100%;
  background-size: contain;
  &:hover {
    opacity: .4;
  }
}
button.all {
  background-size: 100% 100%;
}
button.top {
  border-radius: 10px;
  padding: 12px 12px;
}
@media screen and (max-width: $tabletWidth) {
  button {
    font-size: 9px;
    padding: 8px 5px;
  }
  button.top {
    padding: 10px 5px;
  }
}
</style>
